(() => {
  const TARGET_METHOD = 'delivery'; // DingDoong value for Local delivery
  const PRESELECT_FLAG = '__dtx_dingdoong_preselect_local_delivery_applied__';
  const ROOT_SELECTOR = '.dtx-cart-drawer [id^="ot-dingdoong-root"], .dtx-cart-page [id^="ot-dingdoong-root"], [id^="ot-dingdoong-root"]';

  /**
   * DingDoong renders using `window.dingdoongAppMetafields`.
   * We override the default method to ensure the cart is marked as "Local delivery"
   * so Checkout does not end up with no available shipping.
   */
  const applyPreselect = () => {
    const mf = window.dingdoongAppMetafields;
    const sg = mf?.data?.shopGeneral;
    if (!sg) return false;

    if (window[PRESELECT_FLAG]) return true;

    if (sg.defaultMethod !== TARGET_METHOD) sg.defaultMethod = TARGET_METHOD;
    if (mf?.data?.appearance && mf.data.appearance.defaultMethod !== undefined) {
      mf.data.appearance.defaultMethod = TARGET_METHOD;
    }

    try {
      if (typeof window.dingdoongReRenderWidget === 'function') window.dingdoongReRenderWidget();
    } catch {
      // no-op
    }

    window[PRESELECT_FLAG] = true;
    return true;
  };

  /** Keeps the date picker expanded instead of a collapsed dropdown. */
  const openCalendar = () => {
    const roots = document.querySelectorAll(ROOT_SELECTOR);
    if (!roots.length) return false;

    roots.forEach((root) => {
      const button = root.querySelector('.ot-dingdoong-dropdown__button');
      if (button?.getAttribute('aria-expanded') !== 'true') {
        button.click();
      }

      root.querySelectorAll('.ot-dingdoong-dropdown__content, .ot-dingdoong-dropdown__layer, .ot-dingdoong-calendar').forEach((panel) => {
        panel.hidden = false;
        panel.removeAttribute('hidden');
        panel.setAttribute('aria-hidden', 'false');
      });
    });

    return true;
  };

  const sync = () => {
    applyPreselect();
    openCalendar();
  };

  sync();

  const obs = new MutationObserver(sync);
  obs.observe(document.documentElement, { subtree: true, childList: true });

  setTimeout(() => obs.disconnect(), 15000);
})();
